import { Typography } from '@notch-ordering/ui-components';
import React from 'react';
import { EXTERNAL_URLS } from '@v2/constants/ExternalUrls';
const EditingAddOnOrderNotice = () => (
  <Typography as='div' weight='font-medium' className="checkout-editing-message">
    This order has already been sent to your vendor. You can now only add new
    items. If you wish to remove anything, please{' '}
    <a href={EXTERNAL_URLS.HELP_DESK} target="_blank" rel="noopener noreferrer"> 
      contact support
    </a>
    .
  </Typography>
);

export default EditingAddOnOrderNotice;
